import TimelineVideo from "../../../../timeline/TimelineVideo/TimelineVideo";

const VideoPreview = require('../../../../../assets/img/timeline/modal/2005-Hera.jpg');

const HeraContent = () => {
    return (
        <>
            <TimelineVideo videoId="zlj_-JunajI" imagePreview={VideoPreview} />
            <h4>
                Results of the HERA clinical trial
            </h4>
            <p>
                Results from the HERA clinical trial show that trastuzumab (Herceptin) following standard chemotherapy reduces the risk of recurrence for women with early stage HER2-positive breast cancer by 46%. This trial led to the introduction of trastuzumab in routine clinical practice worldwide. Breast Cancer Trials recruited 110 women this important international study, from Australia and New Zealand, and the Study Chair was Associate Professor Nicholas Wilcken.
            </p>
        </>
    );
}

export default HeraContent;